export enum DroppedType {
    False,
    True
}